import { useEffect, useRef } from 'react';
import debounce from 'lodash/debounce';

const handleScroll = () => {
  // eslint-disable-next-line no-undef
  const $summaryChart = $('#summary-chart');
  if ($summaryChart.length && $summaryChart.hasClass('show')) {
    $summaryChart.collapse('hide');
  }
};

const debouncedHandleScroll = debounce(handleScroll, 100);

// Trigger Jquery collapse on the summary chart to hide it as the user starts
// scrolling to reveal more photos
const useCollapseOnScroll = () => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const element = scrollRef.current;
    if (!element) {
      return;
    }

    element.addEventListener('scroll', debouncedHandleScroll);

    return () => {
      element.removeEventListener('scroll', debouncedHandleScroll);
    };
  }, []);

  return scrollRef;
};

export default useCollapseOnScroll;
